module.exports = {"pt_BR":{"search":"Busca","notfound":"Emoji n�o encontrado","categories":{"search":"Resultado da busca","recent":"Utilizados recentemente","people":"Smileys & Pessoas","nature":"Animais & Natureza","foods":"Comidas & Bebidas","activity":"Atividades","places":"Viajens & Lugares","objects":"Objetos","symbols":"S�mbolos","flags":"Bandeiras","custom":"Diversos"}}}


//////////////////
// WEBPACK FOOTER
// ./sources/i18n/i18n-emoji.json
// module id = 423
// module chunks = 1